import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledFlexiCalendarBoxDiv = styled.div`
  position: relative;
  padding: ${toRem(18)} ${toRem(32)} ${toRem(6)} ${toRem(32)};
  @media ${theme.mediaQuery.mobileOnly} {
    padding: ${toRem(18)} ${toRem(16)} ${toRem(6)} ${toRem(16)};
    background: ${theme.color['white-smoke']};
    .search__flexible_calendar {
      margin-top: 0;
    }
  }

  .months-container {
    padding-top: ${toRem(24)};
    padding-bottom: ${toRem(24)};
    height: ${toRem(325)};
    @media ${baseVariables.mediaQuery.md} {
      height: auto;
    }

    overflow-y: auto;
    &__quesLabel {
      margin-bottom: ${toRem(6)};
    }
  }
  .display-year {
    color: ${theme.color['dove-grey']};
    margin-bottom: ${toRem(4)};
  }
  .months-cta {
    margin-bottom: ${toRem(16)};
    margin-right: ${toRem(6)};
    padding: ${toRem(5)};
    width: ${toRem(98)};
    @media ${theme.mediaQuery.mobileOnly} {
      width: ${toRem(105)};
    }
    @media ${theme.mediaQuery.tablet} {
      min-width: ${toRem(115)};
    }
    @media ${theme.mediaQuery.desktop} {
      min-width: none;
    }
    border: ${toRem(1)} solid ${theme.color['close-silver']};

    &:active {
      background: ${theme.color['cod-grey']};
      border: ${toRem(1)} solid ${theme.color['mine-shaft']};
      color: #fff;
    }
  }
  .stepper-container {
    display: flex;
    padding-bottom: ${toRem(18)};
    border-bottom: ${toRem(1)} solid ${theme.color['close-silver']};
    align-items: center;
    &__label {
      margin-right: ${toRem(30)};
    }
    &__counter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: ${toRem(116)};
      &__btn {
        background: none;
      }
    }
  }
  .selected-month {
    background: ${theme.color['light-gray-3']} !important;
    border: ${toRem(2)} solid ${theme.color['mine-shaft']} !important;
    box-shadow: none !important;
    color: ${theme.color['cod-grey']} !important;
    width: ${toRem(140)};
    @media ${theme.mediaQuery.mobileOnly} {
      width: ${toRem(128)};
    }
  }
  .check-mark {
    color: ${theme.color['black']};
    margin-right: ${toRem(3)};
    margin-left: ${toRem(-5)};
  }
  .disable-btn {
    opacity: 0.4;
    pointer-events: none;
  }
`;
